import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 3 2",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 3,
		height: 2,
		fill: "#fff"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 1.5,
		cy: 1,
		r: .6,
		fill: "#BC002D"
	})]
});
export default SvgJp;
